import { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import ExportWarningDialog from "../Modal/ExportWarningDialog";
import { MAX_ROW_EXPORT } from "../../const/export";
import { toast } from "react-hot-toast";

interface ExportButtonWithWarningProps {
  total: number;
  onExport: () => Promise<void>;
  label?: string;
  loadingLabel?: string;
  disabled?: boolean;
  successMessage?: string;
  errorMessage?: string;
  exportable?: boolean;
}

const ExportButtonWithWarning = ({
  total,
  onExport,
  label = "Export CSV",
  loadingLabel = "Exporting...",
  disabled = false,
  successMessage = "Export successfully!",
  errorMessage = "Export failed. Please try again.",
  exportable = true,
}: ExportButtonWithWarningProps) => {
  const [loading, setLoading] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  const handleClick = () => {
    if (!exportable) {
      toast.error("Access not available for your role.");
      return;
    }
    if (total > MAX_ROW_EXPORT) {
      setShowWarning(true);
    } else {
      handleExport();
    }
  };

  const handleCloseWarning = (confirmed: boolean) => {
    setShowWarning(false);
    if (confirmed) {
      handleExport();
    }
  };

  const handleExport = async () => {
    try {
      setLoading(true);
      await onExport();
      toast.success(successMessage);
    } catch (error) {
      console.error("Export error:", error);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        startIcon={
          loading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            <FileDownloadOutlinedIcon />
          )
        }
        sx={{ borderRadius: "40px", bgcolor: "black" }}
        size="large"
        disabled={loading || disabled}
        onClick={handleClick}
        color="inherit"
      >
        {loading ? loadingLabel : label}
      </Button>

      <ExportWarningDialog
        open={showWarning}
        totalRows={total}
        onClose={handleCloseWarning}
        isLoading={loading}
      />
    </>
  );
};

export default ExportButtonWithWarning;

